import { render, staticRenderFns } from "./WidgetBase.vue?vue&type=template&id=18842cd9&scoped=true&"
import script from "./WidgetBase.vue?vue&type=script&lang=js&"
export * from "./WidgetBase.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBase.vue?vue&type=style&index=0&id=18842cd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18842cd9",
  null
  
)

export default component.exports